import {MithraMaterializedApi} from "../services/MithraMaterializedApi";
import AuthStore from "../authentication/AuthStore";
import ProfileStore from "./ProfileStore";
import {makeAutoObservable, reaction} from "mobx";
import {BagStore} from "./BagStore";
import {GRPageController} from "../pages/golden-record/controllers/GRPageController.ts";

export class GoldenRecordStore {
    readonly grPageController: GRPageController;
    databagId?: number;

    constructor(
        private api: MithraMaterializedApi,
        private auth: AuthStore,
        private profile: ProfileStore,
        private bagStore: BagStore,
    ) {
        this.grPageController = new GRPageController(this, api, auth, profile, bagStore);
        makeAutoObservable(this);
        reaction(() => ([this.bagStore.bagId]), ([bagId]) => {
            this.databagId = bagId;
        });
    }
}